import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23a140ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "transcription" }
const _hoisted_2 = {
  key: 0,
  class: "select is-truncated"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "No entities", -1))
const _hoisted_4 = ["value"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "is-clearfix" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EditionForm = _resolveComponent("EditionForm")!
  const _component_Actions = _resolveComponent("Actions")!
  const _component_Box = _resolveComponent("Box")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.editing)
      ? (_openBlock(), _createBlock(_component_EditionForm, {
          key: 0,
          element: _ctx.element,
          transcription: _ctx.transcription,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editing = false))
        }, null, 8, ["element", "transcription"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_Actions, {
            class: "is-pulled-right mb-1",
            element: _ctx.element,
            transcription: _ctx.transcription,
            onEdit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editing = true))
          }, null, 8, ["element", "transcription"]),
          (_ctx.entityFilterValues.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.workerRunFilter) = $event))
                }, [
                  _hoisted_3,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityFilterValues, ([id, name]) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: id,
                      value: id
                    }, _toDisplayString(_ctx.truncateSelect(name)), 9, _hoisted_4))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.workerRunFilter]
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_5,
          _createVNode(_component_Box, {
            transcription: _ctx.transcription,
            "worker-run-filter": _ctx.workerRunFilter
          }, null, 8, ["transcription", "worker-run-filter"])
        ], 64))
  ]))
}